import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "col-xxl-12 mb-5" }, null, -1)
const _hoisted_2 = { class: "col-xxl-12 mb-5" }
const _hoisted_3 = {
  key: 0,
  class: "col-xxl-12 mt-5"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "col-xxl-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalanceDetails = _resolveComponent("BalanceDetails")
  const _component_ProductGCProcess = _resolveComponent("ProductGCProcess")
  const _component_ProductGCHistory = _resolveComponent("ProductGCHistory")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_BalanceDetails, { "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8" })
    ]),
    (!_ctx.isOverriden)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            (!_ctx.loading)
              ? (_openBlock(), _createBlock(_component_ProductGCProcess, {
                  key: 0,
                  gcmodeldata: _ctx.gcmodeldata,
                  "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8"
                }, null, 8, ["gcmodeldata"]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_5, [
      (!_ctx.loading)
        ? (_openBlock(), _createBlock(_component_ProductGCHistory, {
            key: 0,
            "widget-classes": "card-xxl-stretch mb-5 mb-xxl-8"
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}